module.exports = __webpack_public_path__ + "img/globe.50d70b6d.svg";